import {ADD_TOAST, REMOVE_TOAST, REMOVE_TOAST_FROM_STATE} from '../actions/index';

/**
 * Add a toast programmatically.
 * @param {array} state - array of toasts in the stack
 * @param {Toast} toast - toast to add to the toaster
 */
export const addToast = (state = [], toast = {}) => {
    const canAddToast = !!(typeof toast.id === 'number' && toast.content);
    if (!canAddToast) {
        return state;
    }
    const toasts = state.slice(0);
    toasts.push(toast);
    return toasts;
};

/**
 * Remove a toast programmatically.
 * @param {array} state - array of toasts in the stack
 * @param {string} id - id of the toast to remove
 */
export const removeToast = (state = [], id) => {
    if (typeof id !== 'number') {
        return state;
    }
    const idx = state.findIndex((toast) => toast.id === id);
    const toast = state[idx];

    if (!toast) {
        return state;
    }

    const toasts = state.slice(0);
    toast.remove = true;
    toasts[idx] = toast;
    return toasts;
};

/**
 * Internal reducer to officially remove a toast from the stack after
 * it has removed itself from the UI.
 * @param {array} state - array of toasts in the stack
 * @param {string} id - id of the toast to remove from the stack
 */
export const removeToastFromState = (state = [], id) => {
    if (typeof id !== 'number') {
        return state;
    }
    return state.filter((toast) => toast.id !== id);
};

export default function toaster(state = [], {payload = {}, type} = {}) {
    const {id} = payload;
    switch (type) {
        case ADD_TOAST:
            const toast = payload;
            return addToast(state, toast);
        case REMOVE_TOAST:
            return removeToast(state, id);
        case REMOVE_TOAST_FROM_STATE:
            return removeToastFromState(state, id);
        default:
            return state;
    }
}
